import * as React from 'react';
import { Modal, Button, FormControl, Alert } from 'react-bootstrap';
import { IDashSearchResult } from '@nkr/models/index';
import { ClosedLoopAssignType } from '@nkr/enums/index';
import { IFindDashResponse } from '@nkr/store/index';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, ICellRendererParams, SelectionChangedEvent, ValueGetterParams } from 'ag-grid-community';
import { GridWrapper } from '../styles';
import { Utility } from '@nkr/services/utility';

interface IProps {
    show: boolean,
    centerId: number,
    search: string,
    firstName?: string,
    lastName?: string,
    onSearch: (centerId: number, search: string) => Promise<IFindDashResponse>,
    onAssign: (id: number, type: ClosedLoopAssignType) => void,
    onCancel: () => void
}

interface IState {
    search: string,
    searchResults: IDashSearchResult[],
    selectedRegistration: number,
    columnDefs: ColDef[]
}

class FindDash extends React.Component<IProps, IState> {
    readonly state: IState = {
        search: '',
        searchResults: [],
        selectedRegistration: 0,
        columnDefs: [
            {
                headerName: "First Name",
                field: "firstName",
                width: 130,
                valueGetter: (params: ValueGetterParams) => {
                    let data = params.data as IDashSearchResult;

                    if (data.firstName == '') {
                        return '--';
                    }

                    return data.firstName;
                }
            },

            {
                headerName: "Last Name",
                field: "lastName",
                width: 130,
                valueGetter: (params: ValueGetterParams) => {
                    let data = params.data as IDashSearchResult;

                    if (data.firstName == '') {
                        return '--';
                    }

                    return data.firstName;
                }
            },

            {
                headerName: "Email",
                field: "email",
                width: 200
            },

            {
                headerName: "DOB",
                field: "birthDate",
                width: 150,
                comparator: Utility.dateComparator,
                valueGetter: (params: ValueGetterParams) => {
                    let data = params.data as IDashSearchResult;

                    if (data.birthDate == '') {
                        return '--';
                    }

                    return data.birthDate;
                }
            },

            {
                headerName: "Date of Registration",
                field: "registrationDate",
                width: 190,
                comparator: Utility.dateComparator
            }
        ]
    }

    componentWillReceiveProps = (nextProps: IProps) => {
        let search = nextProps.search != '' ? nextProps.search : '';

        this.setState({
            search
        }, () => {
            this.doSearch(search)
        });
    }

    handleSearchChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let search = e.currentTarget.value;

        this.setState({
            search
        }, () => {
            this.doSearch(search);
        });
    }

    handleRowClick = (event: SelectionChangedEvent) => {
        let selectedNodes = event.api.getSelectedNodes();
        let data = selectedNodes.length > 0 ? selectedNodes[0].data as IDashSearchResult : null;

        this.setState({
            selectedRegistration: data != null ? data.id : -1
        });
    }

    handleAssign = () => {
        this.props.onAssign(this.state.selectedRegistration, ClosedLoopAssignType.DASH);
    }

    handleCancel = () => {
        this.props.onCancel();
    }

    doSearch = (search: string) => {
        if (search.length >= 3) {
            this.props.onSearch(this.props.centerId, search).then(response => {
                this.setState({
                    searchResults: response.data.results
                });
            })
        }
    }

    render = () => {
        return (
            <Modal show={this.props.show} bsSize="large" backdrop='static' onHide={this.handleCancel}>
                <Modal.Header closeButton>
                    <Modal.Title>Find DASH Registration</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Alert>Please enter at least three (3) characters to search the first name, last name, email and date of birth. To provide multiple search terms, separate each with a space.</Alert>

                    <FormControl
                        style={{ marginBottom: 5 }}
                        value={this.state.search}
                        onChange={this.handleSearchChange}
                    />

                    <GridWrapper className="ag-theme-bootstrap">
                        <AgGridReact
                            defaultColDef={{
                                sortable: true,
                                suppressMenu: true
                            }}
                            columnDefs={this.state.columnDefs}
                            rowData={this.state.searchResults}
                            rowHeight={25}
                            suppressCellSelection={true}
                            suppressContextMenu={true}
                            rowSelection='single'
                            onSelectionChanged={this.handleRowClick}
                            noRowsOverlayComponentFramework={props =>
                                <>
                                    {this.state.search != '' && this.state.searchResults.length == 0 && (
                                        <>No registrations found...</>
                                    )}

                                    {this.state.search == '' && this.state.searchResults.length == 0 && (
                                        <>Please enter a search term or two...</>
                                    )}
                                </>
                            }
                        />
                    </GridWrapper>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle='primary' onClick={this.handleAssign}>Assign Selected Registration</Button>
                    <Button onClick={this.handleCancel}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default FindDash